import axios from 'axios';

// Detecta Tailscale (100.x.x.x) en tiempo de ejecución para API e imágenes
export const getApiBaseUrl = () => {
  const hostname = window.location.hostname;
  if (hostname.startsWith('100.')) {
    return `http://${hostname}:8002`;
  }
  return process.env.REACT_APP_API_URL || 'http://localhost:5000';
};
const API_BASE_URL = getApiBaseUrl();

// Crear instancia de axios con configuración base
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // 30 segundos
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Interceptor para requests - agregar logs y headers adicionales
apiClient.interceptors.request.use(
  (config) => {
    // Log para desarrollo
    console.log(`🚀 API Request: ${config.method?.toUpperCase()} ${config.url}`);
    
    // Agregar timestamp a todas las requests
    config.headers['X-Request-Time'] = new Date().toISOString();
    
    // Aquí puedes agregar tokens de autenticación si los necesitas
    // const token = localStorage.getItem('authToken');
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`;
    // }
    
    return config;
  },
  (error) => {
    console.error('❌ Request Error:', error);
    return Promise.reject(error);
  }
);

// Interceptor para responses - manejo de errores global
apiClient.interceptors.response.use(
  (response) => {
    console.log(`✅ API Response: ${response.status} ${response.config.url}`);
    return response;
  },
  (error) => {
    console.error('❌ Response Error:', error);
    
    // Manejo de errores específicos
    if (error.response) {
      // Error con respuesta del servidor
      const { status, data } = error.response;
      
      switch (status) {
        case 400:
          console.error('Bad Request:', data.message || data.error);
          break;
        case 401:
          console.error('Unauthorized - Redirecting to login...');
          // Aquí puedes redirigir al login
          break;
        case 403:
          console.error('Forbidden:', data.message || data.error);
          break;
        case 404:
          console.error('Not Found:', data.message || data.error);
          break;
        case 500:
          console.error('Server Error:', data.message || data.error);
          break;
        default:
          console.error(`HTTP ${status}:`, data.message || data.error);
      }
    } else if (error.request) {
      // Error de red o timeout
      console.error('Network Error - No response received:', error.message);
    } else {
      // Error en la configuración de la request
      console.error('Request Setup Error:', error.message);
    }
    
    return Promise.reject(error);
  }
);

// Función helper para manejar errores de forma consistente
export const handleApiError = (error, customMessage = 'Ocurrió un error inesperado') => {
  if (error.response?.data?.message) {
    return error.response.data.message;
  }
  
  if (error.response?.data?.error) {
    return error.response.data.error;
  }
  
  if (error.message) {
    return error.message;
  }
  
  return customMessage;
};

// Función para verificar la salud de la API
export const checkApiHealth = async () => {
  try {
    const response = await apiClient.get('/health');
    return {
      success: true,
      status: response.data.status,
      message: response.data.message,
      timestamp: response.data.timestamp,
    };
  } catch (error) {
    return {
      success: false,
      error: handleApiError(error, 'No se pudo conectar con el servidor'),
    };
  }
};

export default apiClient;